import { combineSlidesValues, today, tomorrow } from './helpers'

export const PRETTY_DATE_FORMAT = 'EEE MMM d, yyyy'

export const AGENCIES = {
  S2N_DEV: 'S2n Agency',
  S2N: 'Spot2Nite Agency',
  FIREFLY: 'Firefly Agency',
}

export const AGENCY_NAMES = {
  S2N: 'Spot2Nite',
}

export const SLIDES = {
  DRIVER: 'driver',
  PASSENGER: 'passenger',
  REAR: 'rear',
}

export const GUESTS = {
  ADULTS: 'adults',
  CHILDREN: 'children',
  INFANTS: 'infants',
  PETS: 'pets',
}

export const UNIT_TYPES = {
  BOAT_SLIP: 'BS',
  LODGING: 'L',
  OTHER: 'O',
  RV_SITE: 'RV',
  RV_TENT_SITE: 'RVT',
  STORAGE: 'S',
  TENT_SITE: 'T',
  VENUE: 'V',
}

export const SITE_TYPES = {
  ALL: 'ALL',
}

export const availableGuestTypes = {
  [AGENCIES.S2N]: [GUESTS.ADULTS, GUESTS.CHILDREN, GUESTS.INFANTS, GUESTS.PETS],
  [AGENCIES.S2N_DEV]: [
    GUESTS.ADULTS,
    GUESTS.CHILDREN,
    GUESTS.INFANTS,
    GUESTS.PETS,
  ],
  [AGENCIES.FIREFLY]: [GUESTS.ADULTS, GUESTS.CHILDREN, GUESTS.PETS],
}

export const availableSlideOptions = {
  [AGENCIES.S2N]: combineSlidesValues([
    SLIDES.DRIVER,
    SLIDES.PASSENGER,
    SLIDES.REAR,
  ]),
  [AGENCIES.S2N_DEV]: combineSlidesValues([
    SLIDES.DRIVER,
    SLIDES.PASSENGER,
    SLIDES.REAR,
  ]),
  [AGENCIES.FIREFLY]: combineSlidesValues([SLIDES.DRIVER, SLIDES.PASSENGER]),
}

export const availableSiteTypes = {
  [AGENCIES.S2N]: [SITE_TYPES.ALL],
  [AGENCIES.S2N_DEV]: [SITE_TYPES.ALL],
}

export const availableUnitTypes = {
  [AGENCIES.S2N]: [UNIT_TYPES.RV_SITE],
  [AGENCIES.S2N_DEV]: [UNIT_TYPES.RV_SITE],
  [AGENCIES.FIREFLY]: [
    UNIT_TYPES.BOAT_SLIP,
    UNIT_TYPES.LODGING,
    UNIT_TYPES.RV_SITE,
    UNIT_TYPES.RV_TENT_SITE,
    UNIT_TYPES.STORAGE,
    UNIT_TYPES.TENT_SITE,
    UNIT_TYPES.VENUE,
    UNIT_TYPES.OTHER,
  ],
}

export const rvYearVisibility = {
  [AGENCIES.FIREFLY]: true,
}

export const availableEquipmentTypes = {
  [AGENCIES.S2N]: [''],
  [AGENCIES.S2N_DEV]: [''],
  [AGENCIES.FIREFLY]: [
    '',
    'FW',
    'MHA',
    'MHB',
    'MHC',
    'PU',
    'T',
    'TT',
    'TC',
    'O',
  ],
}

export const initialSearchStates = {
  [AGENCIES.S2N]: {
    unitType: UNIT_TYPES.RV_SITE,
    siteType: [SITE_TYPES.ALL],
    reservationDates: {
      from: today(),
      to: tomorrow(),
    },
    [GUESTS.ADULTS]: '2',
    [GUESTS.CHILDREN]: '0',
    [GUESTS.INFANTS]: '0',
    [GUESTS.PETS]: '0',
    rvLength: '0',
    rvSlides: SLIDES.DRIVER,
    equipmentType: '',
  },
  [AGENCIES.S2N_DEV]: {
    unitType: UNIT_TYPES.RV_SITE,
    siteType: [SITE_TYPES.ALL],
    reservationDates: {
      from: today(),
      to: tomorrow(),
    },
    [GUESTS.ADULTS]: '2',
    [GUESTS.CHILDREN]: '0',
    [GUESTS.INFANTS]: '0',
    [GUESTS.PETS]: '0',
    rvLength: '0',
    rvSlides: SLIDES.DRIVER,
    equipmentType: '',
  },
  [AGENCIES.FIREFLY]: {
    unitType: UNIT_TYPES.RV_SITE,
    reservationDates: {
      from: today(),
      to: tomorrow(),
    },
    [GUESTS.ADULTS]: '2',
    [GUESTS.CHILDREN]: '0',
    [GUESTS.PETS]: '0',
    rvLength: '30',
    rvSlides: '',
    equipmentType: '',
    manufactureYear: '',
  },
}
